import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Parallax({
  src,
  alt = "",
  className = "",
  overlay = "bg-black/40",
  amount = 90,
  position = "object-center",
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-amount, amount]);

  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        style={{ y, scale: 1.18 }}
        src={src}
        alt={alt}
        loading="lazy"
        className={`absolute inset-0 w-full h-full object-cover ${position}`}
      />
      <div className={`absolute inset-0 ${overlay}`} />
    </div>
  );
}
